<template>
	<button v-if="enabled" v-tooltip="{ content: content.toggleView }" :aria-label="content.toggleView"
		:class="flyerOrientation === 'vertical' ? 'rotate selected' : ''" class="column-toggle btn"
		data-tour-item="orientation" tabindex="0" @click="toggleColumnView" v-bind="config.attrs">

		<svg role="img" viewBox="540.2053 273.8605 19 23.042" width="19" height="22.042" xmlns="http://www.w3.org/2000/svg" aria-labelledby="toggleView">
			<title id="toggleView">Toggle Orientation Icon</title>
			<g transform="matrix(1.4785990715026855, 0, 0, 1, 192.72116088867188, 185.62751770019528)">
				<g>
					<rect
						style="stroke: #545454; fill: rgb(255, 255, 255); fill-opacity: 0; transform-origin: -54.428px 99.754px; stroke-width: 1.3842px;"
						x="235.009" y="88.233" width="12.85" height="23.042" rx="1" ry="1" />
					<g transform="matrix(1.133328, 0, 0, 1.133328, -31.865427, -12.150104)">
						<g id="g-2" transform="matrix(0.03636, 0, 0, 0.029297, 231.960709, 91.129326)" style="" />
					</g>
				</g>
			</g>
			<polygon
				points="550.302 291.392 550.302 278.358 551.833 279.889 552.566 279.158 549.783 276.375 547 279.158 547.733 279.889 549.265 278.357 549.265 291.393 547.733 289.86 547 290.592 549.783 293.375 552.566 290.592 551.833 289.86"
				style="" />
		</svg>
		<span class="panel-label">{{ flyerOrientation === 'vertical' ? content.horizontal : content.vertical }} </span>
	</button>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import featureMixin from "@/mixins/featureMixin";

export default {
	name: "ToggleFlyerOrientationButtonV2",
	mixins: [featureMixin],
	data() {
		return {
			featurePath: 'toggleView'
		}
	},
	computed: {
		...mapGetters(['content']),
		...mapGetters('screen', ["flyerOrientation"]),
		...mapGetters('config', ['features'])
	},
	methods: {
		...mapActions(["toggleColumnView"])
	}
}
</script>

<style lang="scss" scoped>
[mode="desktop"] {
	button.column-toggle {
		min-width: 82px;
		margin-top:4px;
	}
}

[mode='tablet'],
[mode='mobile'] {
	button.column-toggle {
		display: none
	}
}

button.column-toggle {
	&.selected {
		background: unset !important;
		color: unset !important;
	}

	&:hover {
		color: var(--secondary-color) !important;

		svg {
			rect {
				stroke: var(--secondary-color) !important;
			}

			polygon {
				fill: var(--secondary-color);
			}
		}
	}
}


.rotate svg {
	transform: rotate(90deg);
}</style>
